import { render, staticRenderFns } from "./RandomSets.vue?vue&type=template&id=2c224a46&scoped=true"
import script from "./RandomSets.vue?vue&type=script&lang=js"
export * from "./RandomSets.vue?vue&type=script&lang=js"
import style0 from "./RandomSets.vue?vue&type=style&index=0&id=2c224a46&prod&scoped=true&lang=css"
import style1 from "./RandomSets.vue?vue&type=style&index=1&id=2c224a46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c224a46",
  null
  
)

export default component.exports